import {initSentry} from '@zzng/common/utils/matrix';

export const mergeSentry = (tags: {[key: string]: string}) => {
  initSentry({
    dsn: MATRIX_DSN,
    origin: EXCLUSIVE_ORIGIN,
    tags
  });
};
